<template>
    <div class="download-button" :class="{ 'icon-only': this.icon }">
        <i class="icon-file_download"></i>
        <span v-if="!this.icon">
            {{ $t("general.download") }}
        </span>
    </div>
</template>
<script lang="ts">
export default {
    name: "ShareButton",
    props: {
        icon: {
            type: Boolean,
            default: false
        }
    }
};
</script>
<style scoped>
.download-button:not(.icon-only) {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0 15px;
    font-size: 2em;
    background-color: var(--secondary);
    color: var(--buttonTextColor);
    font-size: calc(var(--vh) * 2.5);
    border-top-left-radius: 15% 50%;
    border-top-right-radius: 15% 50%;
    border-bottom-left-radius: 15% 50%;
    border-bottom-right-radius: 15% 50%;
    line-height: calc(var(--vh) * 6);
    height: calc(var(--vh) * 6);
}

.download-button:not(.icon-only) i {
    margin-right: 5px;
}

.download-button.icon-only {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: var(--buttonTextColor);
    font-weight: 500;
    background-color: rgba(100, 100, 100, 0.5);
    border-radius: 50%;
    font-size: calc(var(--vh) * 3.5);
    height: calc(var(--vh) * 6);
    width: calc(var(--vh) * 6);
}

.download-button.icon-only i {
    color: var(--buttonTextColor);
}
</style>
